var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_setup.isAuth)?_c(_setup.SystemBar):_vm._e(),_c(_setup.AppBar)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }